var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table__container"},[_c('table',{staticClass:"elanco"},[_c('ReportTableHeader'),_c('ReportTableBody')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }